<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M22 10.6V13.4C22 13.7312 21.6645 14 21.25 14L2.75 14C2.3355 14 2 13.7312 2 13.4V10.6C2 10.2688 2.3355 10 2.75 10H21.25C21.6645 10 22 10.2688 22 10.6Z"/>
</svg>
